<template>
  <div v-loading.fullscreen="loading">
    <div class="header-scroll">
      <div class="header">
        <el-button
          class="header-button"
          type="info"
          @click="$router.push({ name: 'DeputyList' })"
        >
          Orqaga
        </el-button>

        <el-input
          v-model="search"
          placeholder="Okrug nomi bo'yicha qidirish"
          clearable
          class="header-control"
          @input="onSearch"
          @clear="onSearch"
        />

        <el-button
          class="header-button header-button--right"
          type="success"
          :loading="downloadingExcel"
          @click="downloadOkrugsExcel"
        >
          <img
            src="@/assets/images/icons/download.svg"
            alt=""
            style="margin-right: 5px"
          />
          Excel
        </el-button>

        <MfExcelImport
          class="header-button"
          :action="okrugsImportUrl"
          dialog-title="Mahallalarni okruglarga Excel orqali bog'lash"
          button-text="Excel import"
          button-type="warning"
          :columns="['Okrug_id', 'Quarter_id']"
          :summary-fields="okrugImportSummary"
          template-name="okruglar-shablon.csv"
          @completed="getOkrugs"
        />

        <el-button
          class="header-button"
          type="primary"
          @click="openCreateDialog"
        >
          Qo'shish
        </el-button>
      </div>
    </div>

    <el-table :data="okrugs" border height="calc(100vh - 270px)">
      <el-table-column type="index" :index="indexMethod" width="60" />
      <el-table-column prop="title" label="Nomi" min-width="200" />
      <el-table-column label="Mahallalar" min-width="110" align="center">
        <template #default="scope">
          {{ scope.row.quarters_count || 0 }}
        </template>
      </el-table-column>
      <el-table-column label="Aholi" min-width="120" align="center">
        <template #default="scope">
          {{ formatNumber(scope.row.citizen_count) }}
        </template>
      </el-table-column>
      <el-table-column label="Holati" min-width="120">
        <template #default="scope">
          <el-tag :type="scope.row.is_active ? 'success' : 'info'">
            {{ scope.row.is_active ? "Faol" : "Faol emas" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Yaratilgan vaqti" min-width="170">
        <template #default="scope">
          {{
            scope.row.created_at
              ? $moment(scope.row.created_at).format("DD-MM-YYYY / HH:mm")
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column width="240" label="Amallar" fixed="right">
        <template #default="scope">
          <div class="action-grid">
            <el-button
              size="small"
              type="warning"
              @click="goToQuarters(scope.row)"
            >
              Mahallalar
            </el-button>
            <el-button
              size="small"
              type="primary"
              @click="openEditDialog(scope.row)"
            >
              Tahrirlash
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click="onDelete(scope.row)"
            >
              O'chirish
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <div>Okruglar soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      v-model="showDialog"
      :title="form.id ? 'Okrugni tahrirlash' : 'Okrug qo\'shish'"
      width="500px"
      @closed="resetForm"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
        <el-form-item label="Nomi" prop="title">
          <el-input
            v-model="form.title"
            placeholder="Okrug nomini kiriting"
            size="large"
          />
        </el-form-item>

        <el-form-item label="Nomi (uz)">
          <el-input
            v-model="form.title_lang.uz"
            placeholder="O'zbekcha nomi"
            size="large"
          />
        </el-form-item>

        <el-form-item label="Nomi (ru)">
          <el-input
            v-model="form.title_lang.ru"
            placeholder="Ruscha nomi"
            size="large"
          />
        </el-form-item>

        <el-form-item v-if="form.id" label="Holati">
          <el-switch
            v-model="form.is_active"
            active-text="Faol"
            inactive-text="Faol emas"
          />
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showDialog = false">Bekor qilish</el-button>
          <el-button type="primary" @click="onSubmit">Saqlash</el-button>
        </span>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import MfExcelImport from "@/components/core/MfExcelImport.vue";
import { formatterPrice, blobErrorMessage } from "@/utils/common";

export default {
  name: "OkrugList",
  components: { MfExcelImport },
  data() {
    return {
      loading: false,
      downloadingExcel: false,
      okrugImportSummary: [
        { key: "quarters_linked", label: "Bog'langan mahallalar" },
      ],
      okrugs: [],
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      search: "",
      searchTimer: null,
      showDialog: false,
      form: {
        id: null,
        title: "",
        title_lang: { uz: "", ru: "" },
        is_active: true,
      },
      rules: {
        title: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
          { min: 2, message: "Kamida 2 ta belgi", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    okrugsImportUrl() {
      return `${process.env.VUE_APP_BASE_API_URL}api/v1/deputyv2/okrugs-sync-excel`;
    },
  },
  methods: {
    indexMethod(index) {
      return this.limit * (this.currentPage - 1) + index + 1;
    },
    formatNumber(value) {
      return formatterPrice(value || 0);
    },
    getFileName(headers, fallback) {
      const contentDisposition =
        headers?.["content-disposition"] || headers?.["Content-Disposition"];
      if (!contentDisposition) return fallback;
      const part = contentDisposition
        .split(";")
        .find((item) => item.trim().startsWith("filename="));
      if (!part) return fallback;
      return decodeURIComponent(
        part.split("=")[1].trim().replace(/^"(.*)"$/, "$1")
      );
    },
    downloadOkrugsExcel() {
      this.downloadingExcel = true;
      this.$http
        .get("api/v1/deputyv2/okrugs-excel", { responseType: "blob" })
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.getFileName(res.headers, "okruglar.xlsx"));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        })
        .catch(async ({ response }) => {
          ElNotification({
            title: "Ogohlantirish",
            message: await blobErrorMessage(
              response,
              "Excel yuklashda xatolik sodir bo'ldi!"
            ),
            type: "warning",
          });
        })
        .finally(() => {
          this.downloadingExcel = false;
        });
    },
    getOkrugs(noCache = false) {
      this.loading = true;
      this.$http
        .get("api/v1/deputyv2/okrugs", {
          params: {
            search: this.search || null,
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
            cache: noCache ? "off" : null,
          },
        })
        .then(({ data }) => {
          this.okrugs = data.okrugs || [];
          this.totalCount = data.count || 0;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.getOkrugs();
      }, 400);
    },
    openCreateDialog() {
      this.resetForm();
      this.showDialog = true;
    },
    openEditDialog(row) {
      this.form = {
        id: row.id,
        title: row.title || "",
        title_lang: {
          uz: row.title_lang?.uz || "",
          ru: row.title_lang?.ru || "",
        },
        is_active: !!row.is_active,
      };
      this.showDialog = true;
    },
    resetForm() {
      this.form = {
        id: null,
        title: "",
        title_lang: { uz: "", ru: "" },
        is_active: true,
      };
      this.$refs.formRef?.clearValidate();
    },
    buildPayload() {
      const titleLang = {};
      if (this.form.title_lang.uz?.trim()) {
        titleLang.uz = this.form.title_lang.uz.trim();
      }
      if (this.form.title_lang.ru?.trim()) {
        titleLang.ru = this.form.title_lang.ru.trim();
      }

      const payload = { title: this.form.title.trim() };
      if (Object.keys(titleLang).length) {
        payload.title_lang = titleLang;
      }
      if (this.form.id) {
        payload.is_active = this.form.is_active;
      }
      return payload;
    },
    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        this.loading = true;
        const payload = this.buildPayload();
        const request = this.form.id
          ? this.$http.put(`api/v1/deputyv2/okrugs/${this.form.id}`, payload)
          : this.$http.post("api/v1/deputyv2/okrugs", payload);

        request
          .then(() => {
            ElNotification({
              title: "Tabriklaymiz",
              message: "Muvaffaqiyatli saqlandi",
              type: "success",
            });
            this.showDialog = false;
            this.getOkrugs();
          })
          .catch(({ response }) => {
            ElNotification({
              title: "Xatolik",
              message: response?.data?.message || "Iltimos, qayta urinib ko'ring.",
              type: "error",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    onDelete(row) {
      ElMessageBox.confirm(
        `"${row.title}" okrugini o'chirasizmi?`,
        "Diqqat!",
        {
          confirmButtonText: "Ha",
          cancelButtonText: "Bekor qilish",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`api/v1/deputyv2/okrugs/${row.id}`)
            .then(() => {
              ElMessage({ type: "success", message: "Okrug o'chirildi" });
              if (this.okrugs.length === 1 && this.currentPage > 1) {
                this.currentPage -= 1;
              }
              this.getOkrugs();
            })
            .catch(({ response }) => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: response?.data?.message || "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({ type: "info", message: "O'chirish bekor qilindi" });
        });
    },
    goToQuarters(row) {
      this.$router.push({
        name: "DeputyOkrugQuarters",
        params: { id: row.id },
        query: { title: row.title },
      });
    },
    handleCurrentChange() {
      this.getOkrugs();
    },
    handleSizeChange() {
      this.currentPage = 1;
      this.getOkrugs();
    },
  },
  mounted() {
    this.getOkrugs();
  },
};
</script>

<style scoped>
.header-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 10px;
}

.header {
  display: flex;
  gap: 10px;
  align-items: center;
}

.header-control {
  width: 280px;
  flex-shrink: 0;
}

.header-button {
  flex-shrink: 0;
}

.header-button--right {
  margin-left: auto;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

/* Action buttons in a grid */
.action-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.action-grid :deep(.el-button) {
  margin: 0;
  width: 100%;
}
</style>
